<template>
  <div
    :am-mode="isActive ? 'edit' : 'show'"
    am-allowed-params-item
    @click="editMode()"
    v-click-outside="showMode"
    ref="allowedParams"
    @keyup.esc="showMode"
    tabindex="1"
  >
    <div
      :am-edit="isActive ? '' : null"
      :am-show="isActive ? null : ''"
      :style="isOpenTop ? 'bottom: -4px; top: auto;' : null"
    >
      <div class="_display:flex _flex-wrap:wrap _align-items:center">
        <i-badge
          v-for="value in data.values"
          :key="value.name"
          color="primary"
          am-param-badge
          class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
          @click="isEdit = value.name"
        >
          <p>{{ `${value.display_name}${data.data[value.name].selected.length > 0 ? ' = ' : ''}${data.data[value.name].selected.join()}` }}</p>
          <div v-if="isActive" class="_display:flex _align-items:center">
            <svg viewBox="0 0 24 24" am-icon style="fill: var(--color--secondary-10);">
              <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
            </svg>
          </div>
        </i-badge>
      </div>
      <div v-if="isEdit" class="_margin:1/4">
        <hr>
        <p class="_margin:0">
          {{ data.data[isEdit].display_name }}
        </p>
        <i-checkbox-group
          v-model="val[isEdit].selected"
        >
          <i-checkbox
            v-for="(facing, index) in data.data[isEdit].possible"
            :key="index"
            :value="index"
            class="_margin-y:1/2 _border-color:light"
            size="sm"
            @change="setChangedParts"
          >
            <p>{{ index}} ({{ facing }})</p>
          </i-checkbox>
        </i-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ImageItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isActive: false,
    isEdit: false,
    isOpenTop: false
  }),
  computed: {
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    setChangedParts () {
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data, tag: this.isEdit })
    },
    editMode () {
      this.isActive = true
      this.$emit('editing', this.data.index)
      if (this.$refs.allowedParams.getBoundingClientRect().y / window.innerHeight * 100 > 50) {
        this.isOpenTop = true
      }
    },
    showMode () {
      this.isOpenTop = false
      this.isActive = false
      this.isEdit = false
    }
  }
}
</script>

<style lang="scss">
[am-allowed-params-item] {
  .badge[am-param-badge], .badge[am-param-badge] p {
    cursor: pointer !important;
  }
  .checkbox {
    cursor: default;
    .checkbox-label {
      overflow: hidden;
      cursor: pointer;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0;
      }
      &::before {
        min-width: var(----size);
      }
    }
  }
}
</style>
